<template>
	<div style="position: relative;">
		<div id="mapDiv" class="map_layout"></div>
	</div>

	<div class="page6_main_layout_phone">
		<div class="page6_main_img_1">

		</div>

		<div class="main_map_layout">

			<div style="">
				<!-- 					<div class="page6_about_contact_img">
						
					</div> -->
				<div class="page6_about_content_layout">
					<div style="width: 100%;height: 40px;line-height: 40px;font-size: 24px;text-align: left;margin-left: 30px;
						margin-top: 40px;">
						联系方式
					</div>
					<div style="width: 50px;height: 3px;line-height: 40px;font-size: 24px;text-align: left;margin-left: 30px;
						margin-top: 10px;background-color: #B72024;"></div>

					<div style="width: 100%;height: 40px;line-height: 40px;font-size: 17px;text-align: left;margin-left: 30px;
						margin-top: 20px;">
						联系电话：15927666885
					</div>
					<div style="width: 100%;height: 40px;line-height: 40px;font-size: 17px;text-align: left;margin-left: 30px;
						margin-top: 0px;">
						公司邮箱：sales@aidoeasy.com
					</div>
					<div style="width: 100%;height: 40px;line-height: 40px;font-size: 17px;text-align: left;margin-left: 30px;
						margin-top: 0px;">
						公司网站：www.doeasyit.com
					</div>
					<div style="width: 100%;height: 40px;line-height: 40px;font-size: 17px;text-align: left;margin-left: 30px;
						margin-top: 0px;">
						联系地址：武汉市洪山区关东科技工业园
					</div>
				</div>

			</div>
			<!-- <div id="mapDiv" class="map_layout" ></div> -->
			<!-- <div class="main_map_img_1" ></div> -->

		</div>


	</div>
	<div class="page6_main_layout">
		<div class="page6_main_img_1">
			<!-- 				<div style="
					position: absolute;
					left: 165px;
					color: #ffffff;
					font-size: 60px;
					top: 150px;
					font-weight: 600;
					
					">
					致力于机器视觉
				</div>
				<div style="
					position: absolute;
					left: 100px;
					color: #ffffff;
					font-size: 60px;
					top: 240px;
					font-weight: 600;
					
					">
					自动化设备研发生产
				</div> -->

		</div>
		<!-- <div class="page6_main_layout_2"> -->

		<!-- 				<div class="show_title_line">
					关于我们
				</div>
				<div class="page5_show_1">
					<div class="page5_show_1_text">
						致力于机器视觉，人工智能方案，自动化设备研发生产及系统集成
					</div>
				</div> -->

		<!-- 				<div class="page5_show_2">
					<div class="page5_show_2_text">
						 武汉为之易科技有限公司作为技术创新驱动的企业，汇聚了一批专业素质高、创新能力强劲、实践经验丰富的研发团队。我们不断推动技术进步，研发了系列先进、可靠的设备，以应对市场的变化。我司的系统方案和产品覆盖了光电行业、新能源行业、电子行业等多个领域，从基础模块到系统集成，全方位满足客户需求。
					</div>
					<div class="page5_show_2_text_2">
						为之易始终坚持以市场需求为导向的发展策略，整合行业资源，不断提升在自动化行业中的核心竞争力。我们坚信，凭借产品的高度定制性和灵活性，能够精准满足客户的多样化需求，并与客户携手共创辉煌的未来。
					
					</div>
		
				</div> -->
		<!-- 		<div class="page5_show_3">
					
				</div>
				<div class="page5_show_4">
					
				</div> -->
		<!-- 		<div class="page5_show_5">
					
				</div> -->
		<!-- </div> -->
		<div class="main_map_layout">
			<!-- <div class="page6_about_info_layout">
				<div class="page6_about_text_1">
					<div style="width: 140px;height: 100%;float: left;text-align: left;">
						联系电话：
					</div>
					<div style="width: calc((100% - 220px));height: 100%;float: left;text-align: left;">
						15927666885
					</div>
					
				</div>
				<div class="page6_about_text_2">
					<div style="width: 140px;height: 100%;float: left;text-align: left;">
						公司邮箱：
					</div>
					<div style="width: calc((100% - 220px));height: 100%;float: left;text-align: left;">
						sales@doeasyai.com
					</div>
					
				</div>
			</div> -->
			<div
				style="width: 1200px;height: auto;margin-left: calc((100% - 1200px)/2 );position: relative;margin-top: 40px;color: rgb(102, 102, 102);">
				<div class="page6_about_contact_img">

				</div>
				<div class="page6_about_content_layout">
					<div style="width: 100%;height: 40px;line-height: 40px;font-size: 24px;text-align: left;margin-left: 30px;
					margin-top: 40px;">
						联系方式
					</div>
					<div style="width: 50px;height: 3px;line-height: 40px;font-size: 24px;text-align: left;margin-left: 30px;
					margin-top: 10px;background-color: #00ffff;"></div>

					<div style="width: 100%;height: 40px;line-height: 40px;font-size: 17px;text-align: left;margin-left: 30px;
					margin-top: 20px;">
						联系电话：15927666885
					</div>
					<div style="width: 100%;height: 40px;line-height: 40px;font-size: 17px;text-align: left;margin-left: 30px;
					margin-top: 0px;">
						公司邮箱：sales@aidoeasy.com
					</div>
					<div style="width: 100%;height: 40px;line-height: 40px;font-size: 17px;text-align: left;margin-left: 30px;
					margin-top: 0px;">
						公司网站：www.doeasyit.com
					</div>
					<div style="width: 100%;height: 40px;line-height: 40px;font-size: 17px;text-align: left;margin-left: 30px;
					margin-top: 0px;">
						联系地址：武汉市洪山区关东科技工业园
					</div>
				</div>

				<!-- <div id="mapDiv" class="map_layout" ></div> -->
			</div>

			<!-- <div class="main_map_img_1" ></div> -->

		</div>


	</div>
	<Footer></Footer>

</template>

<script>
import request from "@/utils/request";
import Footer from '@/components/Footer'

export default {
	name: "page6",
	components: {
		Footer
	},
	data() {
		return {
			map_obj: "",

		}
	},
	mounted() {
		document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0

		console.log("====================")
		this.init_map()

		this.$GLOBAL.methods.init_header_menu("page6")
	},
	methods: {
		init_map() {
			this.map_obj = new T.Map('mapDiv');
			var latlng = new T.LngLat(114.4262, 30.50610);
			this.map_obj.centerAndZoom(latlng, 12);
			document.getElementsByClassName("tdt-control-copyright tdt-control")[0].style.display = 'none'
			//创建标注对象
			var marker = new T.Marker(new T.LngLat(114.4262, 30.50610));
			//向地图上添加标注
			this.map_obj.addOverLay(marker);
			var label = new T.Label({
				text: "",
				text: `<div style="
							line-height: 28px;
							font-size: 20px;
							width: 340px;
							height:60px;
							font-family: "楷体","楷体_GB2312";
						">
						<span style="">武汉市洪山区关东科技工业园</span>
						<br/>
						<span style="color: #1296db;font-weight: 600;">武汉为之易科技有限公司</span>
					</div>`,
				position: latlng,
				offset: new T.Point(-188, -80)
			});
			//创建地图文本对象
			this.map_obj.addOverLay(label);
			this.map_obj.setMinZoom(10);
			this.map_obj.setMaxZoom(18);
			this.map_obj.setStyle("indigo")

		},

	},
}
</script>

<style></style>